import React, {useState, useEffect} from 'react'

function ExtraCharge({title,price,img, thisProperty, quantities, setQuantities, handleIncrement, handleDecrement}) {

    // const [enabled, setEnabled] = useState(false);
    const [minus, setMinus] = useState( [<button onClick = { (thisProperty) => { handleDecrement(thisProperty)}}>-</button>]);

    //useEffect to disable the ability to make counts negative
    useEffect( () => {
        if(quantities[thisProperty] <= 0){
            //set to false
            setMinus(<button className= "grayed-out" disabled onClick = { (thisProperty, price) => { handleDecrement(thisProperty)}}>-</button>);
        }else{
            //set to true
            setMinus(<button onClick = { () => { handleDecrement(thisProperty, price)}}>-</button>);
        }
    },[quantities] );

    

  return (
    <>
        <div className= "extra-charge-item-container">
            <div className= "extra-charge-item-header">
                <h3 className= "extra-charge-title">{title}</h3>
                <h4>${price}</h4>
                </div>
            <div className = "extra-charge-item-details">
                <div className= "extra-charge-image-container">
                    <img src={img} alt="" />
                </div>
                <div className= "item-count-container">
                   {minus}
                    <p>{quantities[thisProperty]}</p>
                    <button onClick = { () => { handleIncrement(thisProperty, price)}}>+</button>
                </div>
            </div>
            </div>
    </>


  )
}

export default ExtraCharge;